import {
  ShopperAiSettingsOptimizationSchema,
  UpsertShopperAiSettingsOptimizationSchema,
} from "@redotech/redo-model/shopper-ai-settings-optimization";
import * as zExt from "@redotech/rpc/ext";

export const upsertShopperAiSettingsOptimization = {
  name: "upsertShopperAiSettingsOptimization" as const,
  input: zExt.filterToValid(
    UpsertShopperAiSettingsOptimizationSchema.omit({ userId: true }),
  ),
  output: ShopperAiSettingsOptimizationSchema.optional(),
};
